import type { PropsWithChildren, FunctionComponent } from 'react'
import { useMemo } from 'react'
import { useCurrentAccountDetails } from '../../api/current-account/currentAccount.hooks'
import { ErrorPage } from '../../gin-and-tonic/containers/error-page/ErrorPage'
import { ICPlatformProvider } from '../ic-platform/icPlatform.context'
import { AccountLocaleSync } from './AccountLocaleSync'
import { CurrentAccountContext } from './CurrentAccountContext'

export const CurrentAccountProvider: FunctionComponent<PropsWithChildren<unknown>> = ({
  children,
}) => {
  const { error, loading, account } = useCurrentAccountDetails()

  const contextValue = useMemo(
    () => ({
      account,
    }),
    [account]
  )

  if (loading) return null

  if (error) return <ErrorPage />

  return (
    <CurrentAccountContext.Provider value={contextValue}>
      {/* Sync the user's locale from their account data to the I18n context */}
      <AccountLocaleSync />
      <ICPlatformProvider>{children}</ICPlatformProvider>
    </CurrentAccountContext.Provider>
  )
}
